import _styled, { default as _styled2, default as _styled3 } from "styled-components";
var _class, _HelpPanel, _templateObject, _templateObject2;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { runInAction } from "mobx";
import { observer } from "mobx-react";
import PropTypes from "prop-types";
import { Component } from "react";
import { withTranslation } from "react-i18next";
import { withTheme } from "styled-components";
import { Category, HelpAction } from "../../../../Core/AnalyticEvents/analyticEvents";
import Box from "../../../../Styled/Box";
import Button, { RawButton } from "../../../../Styled/Button";
import Icon, { StyledIcon } from "../../../../Styled/Icon";
import Spacing from "../../../../Styled/Spacing";
import Text from "../../../../Styled/Text";
import parseCustomMarkdownToReact from "../../../Custom/parseCustomMarkdownToReact";
import { withViewState } from "../../../Context";
import HelpPanelItem from "./HelpPanelItem";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const HELP_PANEL_ID = "help";
let HelpPanel = observer(_class = (_HelpPanel = class HelpPanel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isAnimatingOpen: true
    };
  }
  componentDidMount() {
    // The animation timing is controlled in the CSS so the timeout can be 0 here.
    setTimeout(() => this.setState({
      isAnimatingOpen: false
    }), 0);
  }
  componentWillUnmount() {
    // Make sure that retainSharePanel is set to false. This property is used to temporarily disable closing when Share Panel loses focus.
    // If the Share Panel is open underneath help panel, we now want to allow it to close normally.
    setTimeout(() => {
      this.props.viewState.setRetainSharePanel(false);
    }, 500); // We need to re-enable closing of share panel when loses focus.
  }
  render() {
    const {
      t
    } = this.props;
    const helpItems = this.props.viewState.terria.configParameters.helpContent;
    const isExpanded = this.props.viewState.helpPanelExpanded;
    const isAnimatingOpen = this.state.isAnimatingOpen;
    return /*#__PURE__*/_jsxs(_StyledBox, {
      displayInlineBlock: true,
      backgroundColor: this.props.theme.textLight,
      styledWidth: "320px",
      fullHeight: true,
      onClick: () => this.props.viewState.setTopElement("HelpPanel"),
      $_css: this.props.viewState.topElement === "HelpPanel" ? 99999 : 110,
      $_css2: isAnimatingOpen ? -320 : isExpanded ? 490 : 0,
      children: [/*#__PURE__*/_jsx(Box, {
        position: "absolute",
        paddedRatio: 3,
        topRight: true,
        children: /*#__PURE__*/_jsx(RawButton, {
          onClick: () => this.props.viewState.hideHelpPanel(),
          "aria-label": "Close help panel",
          children: /*#__PURE__*/_jsx(StyledIcon, {
            styledWidth: "16px",
            fillColor: this.props.theme.textDark,
            opacity: 0.5,
            glyph: Icon.GLYPHS.closeLight
          })
        })
      }), /*#__PURE__*/_jsxs(_StyledBox2, {
        centered: true,
        paddedHorizontally: 5,
        paddedVertically: 17,
        displayInlineBlock: true,
        children: [/*#__PURE__*/_jsx(Text, {
          extraBold: true,
          heading: true,
          textDark: true,
          children: t("helpPanel.menuPaneTitle")
        }), /*#__PURE__*/_jsx(Spacing, {
          bottom: 4
        }), /*#__PURE__*/_jsx(Text, {
          medium: true,
          textDark: true,
          highlightLinks: true,
          children: parseCustomMarkdownToReact(t("helpPanel.menuPaneBody", {
            supportEmail: this.props.viewState.terria.supportEmail
          }))
        }), /*#__PURE__*/_jsx(Spacing, {
          bottom: 5
        }), /*#__PURE__*/_jsx(Box, {
          centered: true,
          children: /*#__PURE__*/_jsx(_StyledButton, {
            primary: true,
            rounded: true,
            styledMinWidth: "240px",
            onClick: () => {
              var _this$props$viewState;
              (_this$props$viewState = this.props.viewState.terria.analytics) === null || _this$props$viewState === void 0 || _this$props$viewState.logEvent(Category.help, HelpAction.takeTour);
              runInAction(() => {
                this.props.viewState.hideHelpPanel();
                this.props.viewState.setTourIndex(0);
              });
            },
            renderIcon: () => /*#__PURE__*/_jsx(StyledIcon, {
              light: true,
              styledWidth: "18px",
              glyph: Icon.GLYPHS.tour
            }),
            textProps: {
              large: true
            },
            children: t("helpPanel.takeTour")
          })
        })]
      }), /*#__PURE__*/_jsx(Spacing, {
        bottom: 10
      }), /*#__PURE__*/_jsx(Box, {
        centered: true,
        displayInlineBlock: true,
        fullWidth: true,
        styledPadding: "0 26px",
        children: helpItems && helpItems.map((item, i) => /*#__PURE__*/_jsx(HelpPanelItem, {
          terria: this.props.viewState.terria,
          viewState: this.props.viewState,
          content: item
        }, i))
      })]
    });
  }
}, _defineProperty(_HelpPanel, "displayName", "HelpPanel"), _defineProperty(_HelpPanel, "propTypes", {
  viewState: PropTypes.object.isRequired,
  theme: PropTypes.object,
  t: PropTypes.func.isRequired
}), _HelpPanel)) || _class;
export default withTranslation()(withViewState(withTheme(HelpPanel)));
var _StyledBox = _styled(Box)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n          position: fixed;\n          z-index: ", ";\n          transition: right 0.25s;\n          transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n          right: ", "px;\n        "])), p => p.$_css, p => p.$_css2);
var _StyledBox2 = _styled2(Box)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n            direction: ltr;\n            min-width: 295px;\n            padding-bottom: 0px;\n          "])));
var _StyledButton = _styled3(Button).withConfig({
  displayName: "HelpPanel___StyledButton",
  componentId: "sc-vg27s6-0"
})(["", ""], p => p.theme.addTerriaPrimaryBtnStyles(p));